import { Component, OnInit, viewChild } from '@angular/core';
import { QuestionControlService } from '../../../inputfileds/form_services/question-control.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CoursesService } from '../../../inputfileds/form_services/courses/courses.service';
import { MatRadioModule } from "@angular/material/radio";
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import { RemoveUnderscorePipe } from '../../../components/Utilites/Pipe/remove-underscore.pipe';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';


@Component({
  selector: 'app-role-manage',
  imports: [
    RemoveUnderscorePipe, 
    CommonModule, 
    MatRadioModule, 
    MatInputModule, 
    MatSelectModule, 
    MatFormFieldModule,
    ReactiveFormsModule,
    TranslateDirective],
  templateUrl: './role-manage.component.html',
  styleUrl: './role-manage.component.scss',
  providers: [QuestionControlService, CoursesService],
})

export class RoleManageComponent implements OnInit {
  userForm!: FormGroup;
  rolejsondata: any;
  moduleNames: any[] = [];
  selected_module: any;
  permissiondata: any;
  permissionkeys!: string[];
  selectAllMap: { [key: string]: boolean } = {};
  constructor(
    private fb: FormBuilder,
    private services: CoursesService
  ) {}

  ngOnInit(): void {
    const userdata = sessionStorage.getItem('user');
    this.rolejsondata = userdata ? JSON.parse(userdata).data.role_json : null;

    if (this.rolejsondata?.modules) {
      this.moduleNames = this.rolejsondata.modules;
    }
    this.permissiondata = this.rolejsondata.permissions;
    this.permissionkeys = Object.keys(this.permissiondata);
    this.userForm = this.fb.group({});
  }

  onSelectionChange(event: any) {
    const modulename = event.target.value;
    this.selected_module = this.rolejsondata.modules.find(
      (m: any) => m.module_name === modulename
    );

    // reset previous form
    this.userForm = this.fb.group({});

    // helper to create controls
    const addCheckboxes = (prefix: string) => {
      const actions = this.permissionkeys;

      // create controls
      actions.forEach(action => {
        this.userForm.addControl(prefix + action, new FormControl(false));
      });

      // add select all
      this.userForm.addControl(prefix + 'selectAll', new FormControl(false));

      // --- when select all changes ---
      this.userForm.get(prefix + 'selectAll')?.valueChanges.subscribe((checked: boolean) => {
        actions.forEach(action => {
          this.userForm.get(prefix + action)?.setValue(checked, { emitEvent: false });
        });
      });

      // --- when any individual checkbox changes ---
      actions.forEach(action => {
        this.userForm.get(prefix + action)?.valueChanges.subscribe(() => {
          const allChecked = actions.every(a => this.userForm.get(prefix + a)?.value);
          const selectAllControl = this.userForm.get(prefix + 'selectAll');
          if (selectAllControl?.value !== allChecked) {
            selectAllControl?.setValue(allChecked, { emitEvent: false });
          }
        });
      });
    };

    // add for module or submodules
    if (this.selected_module) {
      if (this.selected_module?.sub_modules.length === 0) {
        addCheckboxes('');
      } else {
        this.selected_module?.sub_modules.forEach((sm: any) => {
          addCheckboxes(sm.sub_module_name + '_');
        });
      }
    }
  }

  submitForm() {
  const raw = this.userForm.value;
  const output: any[] = [];

  const modules = this.selected_module?.sub_modules.length
    ? this.selected_module?.sub_modules.map((m: any) => m.sub_module_name)
    : [this.selected_module?.module_name];

  modules.forEach((moduleName: any) => {
    const prefix = this.selected_module?.sub_modules.length ? moduleName + '_' : '';

    const obj: any = { module: moduleName };

    this.permissionkeys?.forEach(action => {
      const controlKey = prefix + action;
      if (raw.hasOwnProperty(controlKey)) {
        obj[action] = raw[controlKey];
      }
    });

    output.push(obj);
  });

  console.log("FINAL OUTPUT:", output);
}
}
